//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/ChartEff";
import axios, { CancelToken } from "axios";

export default {
  components: {
    chartOTP
  },
  data() {
    return {
      refreshComponent: false,
      G1: true,
      G2: true,
      G3: true,
      G4: true,
      VN: true,
      ps: "",
      pe: "",
      ds: "",
      de: "",
      viewby: "Week",
      deptg1: {},
      deptg2: {},
      deptg3: {},
      deptg4: {},
      deptvn: {}
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    let b = await this.defaultDate();

    this.deptg1 = await axios(
      `${this.$apiflask}nygctroom/board4/perform/G1/${this.ps}/${this.pe}`
    );
    this.deptg2 = await axios(
      `${this.$apiflask}nygctroom/board4/perform/G2/${this.ps}/${this.pe}`
    );
    this.deptg3 = await axios(
      `${this.$apiflask}nygctroom/board4/perform/G3/${this.ps}/${this.pe}`
    );
    this.deptg4 = await axios(
      `${this.$apiflask}nygctroom/board4/perform/G4/${this.ps}/${this.pe}`
    );
    this.deptvn = await axios(
      `${this.$apiflask}nygctroom/board4/perform/VN2/${this.ps}/${this.pe}`
    );

    this.loadData();
  },
  watch: {
    viewby: function(newVal, oldVal) {
      this.loadData();
    }
  },
  computed: {
    newStart: function() {
      if (this.viewby == "Week") {
        return this.ps;
      } else {
        return this.ds;
      }
    },
    newEnd: function() {
      if (this.viewby == "Week") {
        return this.pe;
      } else {
        return this.de;
      }
    }
  },
  methods: {
    goPage(routerName) {
      this.$router.push({
        name: routerName
      });
    },

    defaultPeriod() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$apiFix + "2021snapdata.php/defaultweek",
        data: params
      }).then(res => {
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },

    defaultDate() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$apiFix + "2021snapdata.php/defaultdate",
        data: params
      }).then(res => {
        this.ds = res.data.ps;
        this.de = res.data.pe;
      });

      return obj;
    },

    loadData() {
      this.refreshComponent = false;
      this.pulling = setTimeout(() => {
        this.refreshComponent = true;
      }, 500);
    }
  }
};
